import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FormGroup, FormControl, FormLabel, Button, Popover, OverlayTrigger } from 'react-bootstrap'
import * as s from './EliminatorAdmin.scss'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import HtmlEditor from '../../Editors/HtmlEditor'
import { createNotification } from '@severed-links/common.redherrings-reducers/notifications'
import { getEliminatorBroadcastMessageData, sendEliminatorBroadcastMessage } from '@severed-links/common.redherrings-reducers/eliminatorAdmin'
import { trim, endsWith } from 'lodash'

const EliminatorBroadcastMessage = () => {

    const dispatch = useDispatch()
    const seasonId = useSelector(state => state.eliminator.seasonId)
    const seasonName = useSelector(state => state.eliminator.seasonName)
    const seasons = useSelector(state => state.eliminator.seasons)
    const broadcastMessage = useSelector(state => state.eliminatorAdmin.broadcastMessage)
    const editorContent = useSelector(state => state.editors.eliminatorAdminEmailMessageBody)
    const [_seasonName, setSeasonName] = useState('')
    const [messageType, setMessageType] = useState('-2')
    const [subject, setSubject] = useState('')
    const [columns, setColumns] = useState([])
    const [messageTypes, setMessageTypes] = useState([])
    const [body, setBody] = useState(null)
    const [isSending, setSending] = useState(false)

    useEffect(() => {
        if (seasonId) getData()
    }, [seasonId])

    const getData = () => {
        dispatch(getEliminatorBroadcastMessageData(seasonId))
        .then(action => {
            const payload = action.payload || {}
            if (action.error) {
                dispatch(createNotification({
                    type: 'error',
                    headline: 'Broadcast Message',
                    message: payload.message || 'Unable to load the recipient options.',
                    timeout: 6000
                }))
                return
            }
            setMessageType(payload.messageType || '-2')
            setSubject(payload.subject || '')
            setBody(payload.body || '')
            setColumns(payload.columns || [])
            setMessageTypes(payload.messageTypes || [])
        })
        .catch(error => dispatch(createNotification({
            type: 'error',
            headline: 'Broadcast Message',
            message: error && error.message ? error.message : 'Unable to load the recipient options.',
            timeout: 6000
        })))
    }

    const doBroadcastMessage = () => {
        var emailMessage = { messageType, seasonId, subject, body: editorContent }
        setSending(true)
        dispatch(sendEliminatorBroadcastMessage(emailMessage))
        .then(action => {
            const payload = action.payload || {}
            dispatch(createNotification({
                type: payload.messageType || (action.error ? 'error' : 'info'),
                headline: 'Broadcast Message', 
                message: payload.message || (action.error ? 'Unable to send the broadcast message.' : 'Broadcast message request completed.'),
                timeout: 6000 
            }))
            setSending(false)
        })
        .catch(error => {
            dispatch(createNotification({
                type: 'error',
                headline: 'Broadcast Message',
                message: error && error.message ? error.message : 'Unable to send the broadcast message.',
                timeout: 6000
            }))
            setSending(false)
        })
    }

    const insertFieldName = _column => {
        var _editorContent = editorContent
        _editorContent = trim(_editorContent)
        if (endsWith(_editorContent, '</p>')) {
            _editorContent = _editorContent.replace(/\<\/p\>$/g, '')
        }
        _editorContent += `${_column.columnNameInsert}</p>`
        setBody(_editorContent)
    }

    const popoverClick = (
        <Popover id='message-fields-popover' title='Insert a field name' 
            className={s.fieldNamePopover}>
            <div className={s.fieldNamePopoverButtonContainer}>
            {columns && columns.map((c, index) =>
            <Button key={`field-name-popover-${c.columnName}`} size='sm' title={c.columnNameDisplay} 
                tabIndex={-1} variant='light' 
                className={s.fieldNamePopoverButton}
                onClick={() => insertFieldName(c)}>
                {c.columnNameDisplay}
            </Button>
            )}
            </div>
        </Popover>
    )

    return (
        messageTypes ? 
            <div className={s.broadcastComposer}>
                <div className={s.broadcastIntro}>
                    <div className={s.eyebrow}>Email Sender</div>
                    <p>Send an HTML email to the selected Eliminator audience.</p>
                </div>

                <div className={s.broadcastFieldGrid}>
                <FormGroup className={s.broadcastField}>
                    <FormLabel>Recipients</FormLabel>
                    <FormControl as='select' placeholder='Message type...' tabIndex={-1} 
                        onChange={e => setMessageType(e.target.value)} name='messageType'
                        value={messageType}>
                    {messageTypes.map(m => 
                        <option key={m.value} value={m.value}>{m.text}</option>
                    )}
                    </FormControl>
                </FormGroup>

                <FormGroup className={s.broadcastField}>
                    <FormLabel>Subject</FormLabel>
                    <FormControl placeholder='Subject' autoCapitalize='words' name='subject'
                        onChange={e => setSubject(e.target.value)} autoFocus
                        value={subject} />
                </FormGroup>
                </div>

                <FormGroup className={s.broadcastMessageField}>
                    <div className={s.broadcastMessageHeader}>
                        <FormLabel>Message body</FormLabel>
                        <OverlayTrigger trigger='click' placement='top' overlay={popoverClick}>
                            <Button className={s.insertFieldButton} size='sm' tabIndex={-1}>
                                <FontAwesomeIcon name='i-cursor' />
                                <span className='d-none d-sm-inline'>{' '}insert field</span>
                            </Button>
                        </OverlayTrigger>
                    </div>
                    <div className={s.editorShell}>
                        <HtmlEditor content={body} 
                            name={'eliminatorAdminEmailMessageBody'}
                            showToolbar
                            placeholder={'Email message body...'} />
                    </div>
                </FormGroup>

                <div className={s.broadcastActions}>
                    <Button className={s.sendButton} variant='primary'
                        disabled={isSending}
                        onClick={() => doBroadcastMessage()}>
                        <FontAwesomeIcon spin={isSending} name={!isSending ? 'envelope' : 'circle-notch'} /> {!isSending ? 'send' : 'sending...'}
                    </Button>
                </div>
            </div>
        : null
    )
}

export default EliminatorBroadcastMessage
